import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//外考管理相关API

const outsideExam = {
    examCourse: {
        queryList: config => createAPI('/outsideExam/examCourse/queryList', 'post', config),
        item: config => createAPI('/outsideExam/examCourse/item', 'post', config),
        save: config => createAPI('/outsideExam/examCourse/save', 'post', config),
        importWkcj: config => createAPI('/outsideExam/examCourse/importWkcj', 'post', config),
        checkExamStu: config => createAPI('/outsideExam/examCourse/checkExamStu', 'post', config),
        deleteById: config => createAPI('/outsideExam/examCourse/deleteById', 'post', config),
        importApply: config => createAPI('/outsideExam/examCourse/importApply', 'post', config),
    },
    outsideExamManage: {
        queryList: config => createAPI('/outsideExam/outsideExamManage/queryList', 'post', config),
        infoList: config => createAPI('/outsideExam/outsideExamManage/infoList', 'post', config),
        stuList: config => createAPI('/outsideExam/outsideExamManage/stuList', 'post', config),
        saveStu: config => createAPI('/outsideExam/outsideExamManage/saveStu', 'post', config),
        delStu: config => createAPI('/outsideExam/outsideExamManage/delStu', 'post', config),
        exportWKClass: config => createAPI('/outsideExam/outsideExamManage/exportWKClass', 'post', config),
        delFile: config => createAPI('/outsideExam/outsideExamManage/delFile', 'post', config),
        initCombo: config => createAPI('/outsideExam/outsideExamManage/initCombo', 'post', config),
        stuListExport: config => createAPI('/outsideExam/outsideExamManage/stuListExport', 'post', config),
    },
    outsideExamInfo:{
        queryList: config => createAPI('/outsideExam/outsideExamInfo/queryList', 'post', config),
        initCombo: config => createAPI('/outsideExam/outsideExamInfo/initCombo', 'post', config),
        exportList: config => createAPI('/outsideExam/outsideExamInfo/exportList', 'post', config),
        exportPhoto: config => createAPI('/outsideExam/outsideExamInfo/exportPhoto', 'post', config),
    },
    studentSelection:{
        queryList: config => createAPI('/outsideExam/studentSelection/queryList', 'post', config),
        WKStuList: config => createAPI('/outsideExam/studentSelection/WKStuList', 'post', config),
        checkBM: config => createAPI('/outsideExam/studentSelection/checkBM', 'post', config),
        apply: config => createAPI('/outsideExam/studentSelection/apply', 'post', config),
        delWKSelection: config => createAPI('/outsideExam/studentSelection/delWKSelection', 'post', config),
        stuInfo: config => createAPI('/outsideExam/studentSelection/stuInfo', 'post', config),
        jiaoFei: config => createAPI('/outsideExam/studentSelection/jiaoFei', 'post', config),
        saveSupplementInfo: config => createAPI('/outsideExam/studentSelection/saveSupplementInfo', 'post', config),
    },
    certificateManage:{
        queryList: config => createAPI('/outsideExam/certificateManage/queryList', 'post', config),
        save: config => createAPI('/outsideExam/certificateManage/save', 'post', config),
        del: config => createAPI('/outsideExam/certificateManage/del', 'post', config),
    },
};

export default outsideExam;



// WEBPACK FOOTER //
// ./src/api/modules/outsideExam.js